module.exports = __webpack_public_path__ + "img/cloudwalker_package_aqs.ebaea401.jpg";